import { render } from "./notice_music.vue?vue&type=template&id=11c12d50"
import script from "./notice_music.vue?vue&type=script&lang=js"
export * from "./notice_music.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__